import { render, staticRenderFns } from "./ListCalendarEventParticipants.vue?vue&type=template&id=5f83c740&scoped=true"
import script from "./ListCalendarEventParticipants.js?vue&type=script&lang=js&external"
export * from "./ListCalendarEventParticipants.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83c740",
  null
  
)

export default component.exports